import React, { forwardRef } from 'react'

import classNames from 'classnames/dedupe'

import './SemanticButton.css'

type SemanticButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode
  className?: string
  fullWidth?: boolean
}

const SemanticButton = forwardRef<HTMLButtonElement, SemanticButtonProps>(
  ({ children, className, fullWidth, style, ...rest }, ref): JSX.Element => {
    return (
      <button
        className={classNames('SemanticButton', className)}
        style={{
          ...style,
          // @ts-expect-error: the custom properties are valid properties for the style object
          '--semantic-button-width': fullWidth ? '100%' : undefined,
        }}
        ref={ref}
        {...rest}
      >
        {children}
      </button>
    )
  },
)

SemanticButton.displayName = 'SemanticButton'

export { SemanticButton }
